import { render, staticRenderFns } from "./OnlyViewLayout.vue?vue&type=template&id=35e6c62b"
import script from "./OnlyViewLayout.vue?vue&type=script&lang=js"
export * from "./OnlyViewLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports